module.exports = __webpack_public_path__ + "img/kuan_gallery.4ca6d5a0.svg";